// extracted by mini-css-extract-plugin
export var column = "_tz-0";
export var divider = "_tz-2";
export var timePicker = "_tz-1";